import React from 'react';
import {
  BUG_FEATURE_TYPE_LIST,
  BUG_FEATURE_PRIORITY_LIST,
  commonProps,
  BUG_FEATURE_TYPE,
} from './useBugFeatureForm';
import { Controller, useFormContext } from 'react-hook-form';
import { Col, Row, Select, SelectOption, Input, TextArea } from 'components/ui';
import InputLabel from './InputLabel';
import AttachFiles from './AttachFiles';

const BugFeatureForm = ({ disabled }) => {
  const { control, watch } = useFormContext();
  const isBugReport = watch('type') === BUG_FEATURE_TYPE.BUG;

  return (
    <>
      <Row>
        <Col span={isBugReport ? 14 : 24}>
          <Controller
            control={control}
            name="type"
            render={({ field, fieldState }) => {
              return (
                <InputLabel label="Type">
                  <Select
                    {...commonProps({ field, fieldState })}
                    disabled={disabled}
                    name="type"
                    style={{ width: '100%' }}
                  >
                    {BUG_FEATURE_TYPE_LIST.map(rt => (
                      <SelectOption key={rt} value={rt}>
                        {rt}
                      </SelectOption>
                    ))}
                  </Select>
                </InputLabel>
              );
            }}
          />
        </Col>
        {isBugReport && (
          <Col span={10}>
            <Controller
              control={control}
              name="priority"
              render={({ field, fieldState }) => {
                return (
                  <InputLabel label="Priority">
                    <Select
                      {...commonProps({ field, fieldState })}
                      disabled={disabled}
                      name="priority"
                      style={{ width: '100%' }}
                    >
                      {BUG_FEATURE_PRIORITY_LIST.map(p => (
                        <SelectOption key={p} value={p}>
                          {p}
                        </SelectOption>
                      ))}
                    </Select>
                  </InputLabel>
                );
              }}
            />
          </Col>
        )}
      </Row>

      <Row>
        <Controller
          control={control}
          name="summary"
          render={({ field, fieldState }) => {
            return (
              <InputLabel label="Summary">
                <Input
                  {...commonProps({ field, fieldState })}
                  disabled={disabled}
                  type="text"
                />
              </InputLabel>
            );
          }}
        />
      </Row>

      <Row>
        <Controller
          control={control}
          name="description"
          render={({ field, fieldState }) => {
            return (
              <InputLabel label="Description">
                <TextArea
                  {...commonProps({ field, fieldState })}
                  disabled={disabled}
                  style={{ height: 100 }}
                  type="text"
                />
              </InputLabel>
            );
          }}
        />
      </Row>

      <Row>
        <AttachFiles disabled={disabled} />
      </Row>
    </>
  );
};

export default BugFeatureForm;
